<template>
<main class="container-1">

    <div class="container-header">
        <MapDetailHeader :map="map" />
    </div>

    <div class="container-body">

        <div class="map-titlebar">
            <h2 class="map-titlebar__name">{{ map.name }}</h2>
            <router-link class="btn-danger-soft" :to="'/mapas/' + $route.params.idMap + '/eliminar-mapa'">
                <font-awesome-icon icon="trash-alt" class="btn-danger-soft__icon"></font-awesome-icon>
                Eliminar mapa
            </router-link>
        </div>

        <header class="map-head">
            <div class="map-head__text">
                <p v-if="map.desc" class="map-head__desc">{{ map.desc }}</p>
                <p class="map-head__meta">Creado el {{ dateFormatter(map.created_at) }}</p>
            </div>
            <img
                v-if="map.imgurl && !imgError"
                :src="map.imgurl"
                alt="Imagen del mapa"
                class="map-head__img"
                @error="imgError = true"
            />
        </header>

        <!-- Los conteos viven una sola vez, en el encabezado de cada sección (#80);
             la navegación a asignar capas/usuarios ya está en las pestañas del encabezado -->
        <section class="assign-section">
            <h3 class="section-title">
                Capas asignadas
                <span v-if="assignedLayers && assignedLayers.length" class="count-pill">{{ assignedLayers.length }}</span>
            </h3>
            <p v-if="assignedLayers && assignedLayers.length === 0" class="section-empty">
                Este mapa no tiene capas asignadas.
            </p>
            <ul v-else class="chips-list">
                <li v-for="item in assignedLayers" :key="item.id">
                    <router-link v-if="canSeeLayers" class="chip" :to="'/capas/' + item.id">
                        <font-awesome-icon icon="layer-group" class="chip__icon"></font-awesome-icon>
                        <span class="chip__name">{{ item.name }}</span>
                        <span class="chip__go" aria-hidden="true">›</span>
                    </router-link>
                    <span v-else class="chip chip--static">
                        <font-awesome-icon icon="layer-group" class="chip__icon"></font-awesome-icon>
                        <span class="chip__name">{{ item.name }}</span>
                    </span>
                </li>
            </ul>
        </section>

        <section class="assign-section">
            <h3 class="section-title">
                Usuarios asignados
                <span v-if="assignedUsers && assignedUsers.length" class="count-pill">{{ assignedUsers.length }}</span>
            </h3>
            <p v-if="assignedUsers && assignedUsers.length === 0" class="section-empty">
                Este mapa no tiene usuarios asignados.
            </p>
            <ul v-else class="chips-list">
                <li v-for="item in assignedUsers" :key="item.id">
                    <router-link v-if="canSeeUsers" class="chip" :to="'/usuarios/' + item.id">
                        <font-awesome-icon icon="users" class="chip__icon"></font-awesome-icon>
                        <span class="chip__name">{{ userDisplayName(item) }}</span>
                        <span class="chip__go" aria-hidden="true">›</span>
                    </router-link>
                    <span v-else class="chip chip--static">
                        <font-awesome-icon icon="users" class="chip__icon"></font-awesome-icon>
                        <span class="chip__name">{{ userDisplayName(item) }}</span>
                    </span>
                </li>
            </ul>
        </section>

        <section class="assign-section">
            <h3 class="section-title">
                Grupos asignados
                <span v-if="assignedGroups && assignedGroups.length" class="count-pill">{{ assignedGroups.length }}</span>
            </h3>
            <p v-if="assignedGroups && assignedGroups.length === 0" class="section-empty">
                Este mapa no tiene grupos asignados.
            </p>
            <ul v-else class="chips-list">
                <li v-for="item in assignedGroups" :key="item.id">
                    <router-link v-if="canSeeUsers" class="chip" :to="'/usuarios/grupos-de-usuarios/' + item.id">
                        <font-awesome-icon icon="layer-group" class="chip__icon"></font-awesome-icon>
                        <span class="chip__name">{{ item.name }}</span>
                        <span class="chip__go" aria-hidden="true">›</span>
                    </router-link>
                    <span v-else class="chip chip--static">
                        <font-awesome-icon icon="layer-group" class="chip__icon"></font-awesome-icon>
                        <span class="chip__name">{{ item.name }}</span>
                    </span>
                </li>
            </ul>
        </section>

        <section class="assign-section">
            <h3 class="section-title">
                Herramientas habilitadas
                <span v-if="enabledTools.length" class="count-pill">{{ enabledTools.length }}</span>
            </h3>
            <ul class="chips-list">
                <li v-for="tool in enabledTools" :key="tool.id">
                    <span class="chip chip--static">
                        <font-awesome-icon icon="toolbox" class="chip__icon"></font-awesome-icon>
                        <span class="chip__name">{{ tool.label }}</span>
                    </span>
                </li>
            </ul>
        </section>

        <!-- <section class="assign-section">
            <h3 class="section-title">
                Geoprocesos asignados
                <span v-if="assignedGeoprocessings && assignedGeoprocessings.length" class="count-pill">{{ assignedGeoprocessings.length }}</span>
            </h3>
            <p v-if="assignedGeoprocessings && assignedGeoprocessings.length === 0" class="section-empty">
                Este mapa no tiene geoprocesos asignados.
            </p>
            <ul v-else class="chips-list">
                <li v-for="item in assignedGeoprocessings" :key="item.id">
                    <span class="chip chip--static">
                        <font-awesome-icon icon="cogs" class="chip__icon"></font-awesome-icon>
                        <span class="chip__name">{{ item.name }}</span>
                    </span>
                </li>
            </ul>
        </section> -->

    </div>


    <!-- <SideNav
    class="container-sidenav"
    v-bind:links="routesNav"
    >
    </SideNav> -->

</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import MapDetailHeader from '@/components/MapDetailHeader.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {restMap} from '@/components/mixin/restMap.js'
import { MAP_TOOLS } from '@/components/mapControls/mapToolsCatalog.js'

// Tope de chips visibles por sección; el resto se resume en un "+N más"
// que lleva a la vista de asignación correspondiente
const MAX_CHIPS = 15

export default{
    name: 'test',
    mixins: [formatter, restMap],
    data(){
        return{
            // null mientras cargan: así no se muestra el estado vacío antes
            // de tener la respuesta del backend
            assignedLayers: null,
            assignedUsers: null,
            assignedGroups: null,
            assignedGeoprocessings: null,
            imgError: false,
        }
    },
    components:{
        SideNav,
        MapDetailHeader
    },
    computed: {
        // Herramientas del visor habilitadas, en el orden del catálogo (QA-11).
        // getMap ya normaliza null a "todas", así que map.tools siempre es lista.
        enabledTools: function(){
            const enabled = this.map.tools || []
            return MAP_TOOLS.filter(tool => enabled.includes(tool.id))
        },
        canSeeLayers: function(){
            return !!this.$store.getters.getPermissions.layers
        },
        canSeeUsers: function(){
            return !!this.$store.getters.getPermissions.users
        },
        visibleLayers: function(){
            return (this.assignedLayers || []).slice(0, MAX_CHIPS)
        },
        hiddenLayersCount: function(){
            return Math.max(0, (this.assignedLayers || []).length - MAX_CHIPS)
        },
        visibleUsers: function(){
            return (this.assignedUsers || []).slice(0, MAX_CHIPS)
        },
        hiddenUsersCount: function(){
            return Math.max(0, (this.assignedUsers || []).length - MAX_CHIPS)
        },
        visibleGeoprocessings: function(){
            return (this.assignedGeoprocessings || []).slice(0, MAX_CHIPS)
        },
        hiddenGeoprocessingsCount: function(){
            return Math.max(0, (this.assignedGeoprocessings || []).length - MAX_CHIPS)
        },
    },
    props: [],
    methods:{
        userDisplayName: function(user){
            const name = ((user.firstname || '') + ' ' + (user.lastname || '')).trim()
            return name || user.username
        },
        getAssignedLayers: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/layers')
            .then(function (response) {
                // el backend responde null cuando no hay asignaciones
                that.assignedLayers = response.data || [];
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAssignedUsers: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/users')
            .then(function (response) {
                that.assignedUsers = response.data || [];
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAssignedGroups: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/groups')
            .then(function (response) {
                that.assignedGroups = response.data || [];
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
        getAssignedGeoprocessings: function(){
            var that = this;
            this.$http.get(this.$store.getters.backendurl + 'api/v1/maps/' + this.$route.params.idMap + '/geoprocessings')
            .then(function (response) {
                that.assignedGeoprocessings = response.data || [];
            })
            .catch(function (error) {
                console.log(error)
                that.message = error.response.data.message;
            });
        },
    },
    updated () {

    },
    created () {
        this.$store.getters.getPermissions.maps? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getMap();
        this.getAssignedLayers();
        this.getAssignedUsers();
        this.getAssignedGroups();
        this.getAssignedGeoprocessings();
    }
}
</script>

<style lang="scss" scoped>

.map-titlebar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
    margin-bottom: 0.9rem;
}

.map-titlebar__name {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--color-navy);
}

.btn-danger-soft {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.35rem 0.85rem;

    border: 1px solid rgba(178, 58, 46, 0.35);
    border-radius: 6px;
    color: var(--color-danger);

    font-size: 0.82rem;
    font-weight: 600;
    text-decoration: none;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.btn-danger-soft:hover {
    background: #fdf2f2;
    border-color: var(--color-danger);
    color: #922b21;
    text-decoration: none;
}

.btn-danger-soft__icon {
    font-size: 0.8rem;
}

.map-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.25rem;
    margin-bottom: 1.25rem;

    &__text {
        h2 {
            font-size: 1.5rem;
            font-weight: 700;
            color: var(--color-navy);
        }
    }

    &__desc {
        margin-top: 0.35rem;
        color: var(--color-steel);
        font-size: 0.92rem;
        max-width: 70ch;
    }

    &__meta {
        margin-top: 0.35rem;
        color: var(--color-ghost);
        font-size: 0.8rem;
    }

    &__img {
        flex-shrink: 0;
        width: 180px;
        height: 110px;
        object-fit: cover;
        border: 1px solid var(--color-line);
        border-radius: 8px;
    }
}

.assign-section {
    margin-bottom: 1.5rem;
}

.count-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.5rem;
    height: 1.5rem;
    padding: 0 0.4rem;
    margin-left: 0.5rem;
    border-radius: 999px;
    background: var(--color-orange-light);
    color: var(--color-orange);
    font-size: 0.8rem;
    font-weight: 700;
    vertical-align: middle;
}

.section-empty {
    color: var(--color-ghost);
    font-size: 0.9rem;
    padding: 0.5rem 0;
}

.chips-list {
    list-style: none;
    margin: 0;
    padding: 0.5rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 0.5rem;

    /* Cuadro con scroll: se ven todos los elementos sin "+N más" */
    max-height: 15rem;
    overflow-y: auto;
    border: 1px solid var(--color-line);
    border-radius: 8px;
    background: var(--color-white);
}

.chip {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.55rem 0.85rem;
    border: 1px solid var(--color-line);
    border-radius: 6px;
    background: var(--color-white);
    color: var(--color-graphite);
    font-size: 0.9rem;
    font-weight: 500;
    text-decoration: none;
    transition: border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease;

    &:hover {
        text-decoration: none;
    }
}

a.chip:hover {
    border-color: var(--color-steel);
    background: var(--color-mist);
    color: var(--color-navy);

    .chip__go {
        color: var(--color-orange);
        transform: translateX(2px);
    }
}

.chip--more {
    justify-content: center;
    color: var(--color-steel);
    border-style: dashed;

    &:hover {
        border-color: var(--color-steel);
        background: var(--color-mist);
        color: var(--color-navy);
    }
}

.chip__icon {
    color: var(--color-steel);
    font-size: 0.85rem;
    flex-shrink: 0;
}

.chip__name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.chip__go {
    color: var(--color-ghost);
    font-size: 1.1rem;
    line-height: 1;
    transition: color 0.15s ease, transform 0.15s ease;
}

@media only screen and (max-width: 640px) {
    .map-head {
        flex-direction: column;

        &__img {
            width: 100%;
            height: 140px;
        }
    }
}

</style>
